import { Provider } from '@angular/core';
import { CEPRepository, CEP_REPOSITORY } from './repositories/cep.repository';
import { CEPService } from './services/cep.service';

/**
 * Providers para o domínio CEP
 * Configura a injeção de dependência do repositório
 */
export const CEP_PROVIDERS: Provider[] = [
  {
    provide: CEP_REPOSITORY,
    useClass: CEPService
  }
];
